<template>
  <div class="record_cool_div">
    <div class="container"  >
<!--      <span style="&#45;&#45;d: 7"></span>
      <span style="&#45;&#45;d: 6"></span>
      <span style="&#45;&#45;d: 5"></span>
      <span style="--d: 4"></span>
      <span style="--d: 3"></span>-->
      <span style="--d: 2"></span>
      <span style="--d: 1"></span>
      <span style="--d: 0"></span>
      <span style="--d: 1"></span>
      <span style="--d: 2"></span>
      <!-- <span style="--d: 3"></span>
      <span style="--d: 4"></span>
     <span style="&#45;&#45;d: 5"></span>
      <span style="&#45;&#45;d: 6"></span>
      <span style="&#45;&#45;d: 7"></span>-->
    </div>

  </div>
</template>

<script>
export default {
  name: 'MyComponent',
  components: {},
  props: {
    test: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      sum: '0'
    }
  },
  computed: {},
  methods: {
    handleClick () {
      alert('你点击了按钮')
    }
  }
}
</script>

<style scoped>
.container  {
  --h: 14px;
}
.container {
  display: flex;
  align-items: center;
  position: relative;
  height: var(--h);
}
.container span {
  background: linear-gradient(to top, #1edf41 0%, #1edf41 100%);
  width: 4px;
  height: 100%;
  border-radius: calc(var(--h) * 0.2 * 0.5);
  margin-right: 4px;
  animation: loading 2.5s infinite linear;
  animation-delay: calc(0.2s * var(--d));
}
.container span:last-child {
  margin-right: 0px;
}
@keyframes loading {
  0% {
    //background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
    background-image: linear-gradient(to right, #1edf41 0%, #1edf41 100%);
    height: 20%;
    border-radius: calc(var(--h) * 0.2 * 0.5);
  }
  50% {
    //background-image: linear-gradient(to top, #d299c2 0%, #fef9d7 100%);
    background-image: linear-gradient(to top,  #1edf41 0%, #1edf41 100%);
    height: 100%;
    border-radius: calc(var(--h) * 1 * 0.5);
  }
  100% {
    background-image: linear-gradient(to top, #1edf41 0%, #1edf41 100%);
    height: 20%;
    border-radius: calc(var(--h) * 0.2 * 0.5);
  }
}
</style>
